var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$router.currentRoute.path == '/menu')?_c('div',{staticClass:"grey",attrs:{"id":"app"}},[_c('Preloader'),_c('Header'),_c('Footer'),_c('router-view')],1):(_vm.$router.currentRoute.path == '/life-insurance-opportunity')?_c('div',{staticClass:"lio",attrs:{"id":"app"}},[_c('Preloader'),_c('Header'),_c('Footer'),_c('router-view')],1):(_vm.$router.currentRoute.path == '/perks'
  || _vm.$router.currentRoute.path == '/talent-profiling-guide' 
  || _vm.$router.currentRoute.path == '/career-lifestyle-survey'
  || _vm.$router.currentRoute.path == '/career-disturb'
  || _vm.$router.currentRoute.path == '/career-solution'
  || _vm.$router.currentRoute.path == '/career-result'
  || _vm.$router.currentRoute.path == '/bussiness-opportunity-support-scheme'
  || _vm.$router.currentRoute.path == '/question-set-a'
  || _vm.$router.currentRoute.path == '/question-set-b'
  || _vm.$router.currentRoute.path == '/question-set-c'
  || _vm.$router.currentRoute.path == '/question-set-d'
  || _vm.$router.currentRoute.path == '/question-set-e'
  || _vm.$router.currentRoute.path == '/question-set-f'
  || _vm.$router.currentRoute.path == '/question-set-g'
  || _vm.$router.currentRoute.path == '/talent-result'
)?_c('div',{staticClass:"white",attrs:{"id":"app"}},[_c('Preloader'),_c('Header'),_c('Footer'),_c('router-view')],1):_c('div',{attrs:{"id":"app"}},[_c('Preloader'),_c('Header'),_c('Footer'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }